import { AbstractControl, ValidatorFn } from '@angular/forms';

export const THE_RIGHT_EMAIL_REGEXP =
  /^[-a-z0-9~!$%^&*_=+}{'?]+(\.[-a-z0-9~!$%^&*_=+}{'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.([a-z]{2,})|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;

export function fbEmailValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const valid = !(control.value && control.value.length) || THE_RIGHT_EMAIL_REGEXP.test(control.value);

    return valid ? null : { fbInvalidEmail: true };
  };
}
